module.exports = __webpack_public_path__ + "img/logo-for-dark-bg.57485611.svg";